/**
 * Flooded / Red-Purple-Green.
 */ var RedPurpleGreen = [
    /**
     * Violet Props.
     */ {
        variant: 'violet',
        size: '971',
        rotate: -130,
        blur: 19.3,
        x: '-322',
        y: '789'
    },
    /**
     * Green Props.
     */ {
        variant: 'green',
        size: '1045',
        rotate: 130,
        blur: 19.3,
        x: '395',
        y: '602'
    },
    /**
     * Blue Props.
     */ {
        variant: 'blue',
        size: '911',
        rotate: 50,
        blur: 21.3,
        x: '805',
        y: '-211'
    },
    /**
     * Red Props.
     */ {
        variant: 'red',
        size: '986',
        rotate: -130,
        blur: 21.3,
        x: '163',
        y: '-590'
    }
];

export { RedPurpleGreen as default };
//# sourceMappingURL=red-purple-green.es.js.map
